import * as React from "react";
import CartContextProvider, {isCart, useUnsafeCartContext} from "../CartContextProvider/CartContextProvider";
import AddToCartButtonPortal from "../AddToCartButton/AddToCartButtonPortal";
import CartIconPortal, {updateUrlParams} from "../CartIcon/CartIconPortal";
import AddToCartModal from "../../lib/ModalWindow/AddToCartModal";
import VoucherAddedModal from "../../lib/ModalWindow/VoucherAddedModal";
import NewsletterOptInOptOutPortal from "../../newsletter/NewsletterOptInOptOutPortal";
import WishlistPortal from "../../wishlist/WishlistPortal";
import AddToWishlistButtonPortal from "../../wishlist/AddToWishlistButton/AddToWishlistButtonPortal";
import NewsletterRegistration from "../../newsletter/NewsletterRegistration";
import {CustomerAccount} from "../../customer/account/CustomerAccount";
import ProductSeriesPortal from "../../ProductSeries/ProductSeriesPortal";
import ProductListPortal from "../../organisms/productList/ProductListPortal";
import ProductListWishlistButtonsPortal from "../../wishlist/ProductListWishlistButtonsPortal/ProductListWishlistButtonsPortal";
import ConnoxDealsModal from "../../lib/ModalWindow/ConnoxDealsModal";
import {useCustomerSelector} from "../../../store";
import BuildYourOwnString from "../../lib/ModalWindow/BuildYourOwnString/BuildYourOwnString";
import PayPalContextProvider from "../../lib/payments/paypal/PayPalContextProvider";
import CrossSellingPortal from "../../organisms/crossSelling/CrossSelling";
import HeaderSearch from "../../search/HeaderSearch";
import NewProductsPortal from "../../organisms/productList/NewProductsPortal";

export const Cart: React.FC = () => {
  const {customer} = useCustomerSelector();

  if (!customer) {
    return null;
  }

  return (
    <React.Suspense fallback={null}>
      <CartContextProvider>
        <PayPalContextProvider>
          <CartIconPortal
            root={document.getElementById("CartIconRoot")}
            targetNode={document.getElementById("CartIcon")}
          />
        </PayPalContextProvider>
        <AddToCartButtonPortal
          root={document.getElementById("AddToCartButtonRoot")}
          targetNode={document.querySelector(".product-cart__form")}
        />
        <AddToCartModalWrapper />
        <VoucherAddedModal />
        <WishlistPortal />
        <AddToWishlistButtonPortal
          root={document.getElementById("AddToWishlistButtonNew")}
          targetNode={document.querySelector(".product-cart__wishlist")}
        />
        <ProductListPortal />
        <BuildYourOwnString />
        <ProductListWishlistButtonsPortal />
        <CrossSellingPortal />
        <NewProductsPortal />
        <ProductSeriesPortal />
      </CartContextProvider>
      <NewsletterRegistration />
      <NewsletterOptInOptOutPortal />
      <ConnoxDealsModal />
      <HeaderSearch />
      <CustomerAccount element={document.getElementById("CustomerAccountReact")} />
    </React.Suspense>
  );
};

const AddToCartModalWrapper: React.FC = () => {
  const context = useUnsafeCartContext();
  if (!context) {
    return null;
  }

  if (context.itemsAdded.length) {
    return (
      <AddToCartModal
        closeFunction={() => {
          context.setItemsAdded([]);
        }}
        toCartFunction={() => {
          if (!isCart(context)) {
            return;
          }
          context.setItemsAdded([]);
          context.setIsCartVisible(true);
          if (!new URLSearchParams(location.search).get("view")) {
            updateUrlParams("cart");
          }
        }}
        isVisible={true}
        itemIds={context.itemsAdded}
      />
    );
  }

  return null;
};
